export const SEND_OTP_START = 'SEND_OTP_START';
export const SEND_OTP_SUCCESS = 'SEND_OTP_SUCCESS';
export const SEND_OTP_FAIL = 'SEND_OTP_FAIL';
export const SEND_OTP_RESET = 'SEND_OTP_RESET';
